import axios from 'axios';

const baseUrl = window.REACT_APP_ENTITY_API_URL;

export const getEntities = async (offset, searchTerm, region, active, token) => {
    const fetchStr = `${baseUrl}/SimpleEntities`;
    return axios.get(fetchStr,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                limit: 10,
                offset: offset,
                searchTerm: searchTerm,
                region: region,
                activePlants: active
            }
        });
}

export const getEntityGeneration = async (id, start, end, region, token) => {
    var fetchStr = `${baseUrl}/EntityGeneration`;
    if (start && end) {
        fetchStr += `?start=${start}&end=${end}`
    }
    return axios.get(fetchStr,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                id: id,
                region: region
            }
        })

}

export const getEntity = async (id, region, token) => {
    const fetchStr = `${baseUrl}/${id}`;
    return axios.get(fetchStr,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                region: region
            }
        })
        .then(response => response.data);
}

export const getHitPointsForAlerts = async (entityId, alertIds, start, end, region, token) => {
    var fetchStr = `${baseUrl}/AlertHitPoints`
    return axios.get(fetchStr,
        {
            headers: {
                'Authorization': 'Bearer ' + token
            },
            params: {
                entityId: entityId,
                ids: alertIds,
                start: start,
                end: end,
                region: region
            }
        })
}